import GlobalTable from '@/components/probaworkflows_base_components/GlobalTable/GlobalTable.vue';
import {
  ASSIGN_WORKFLOW_TO_TEMPLATE,
  CREATE_WORKFLOW,
  get_headers,
  get_project_id,
  get_token,
  GET_WORKFLOW,
  LIST_TEMPLATE_VIEW_URL,
  LIST_WORFLOWS,
  LIST_WORKFLOW_ASSIGNMENTS,
  ROLES_URL,
  UNASSIGN_WORKFLOW_FROM_TEMPLATE,
  UPDATE_WORKFLOW_URL,
  VIEW_ENTITY_TYPE_URL,
} from '@/utils/constants/constants.js';
import alert_mixin from '@/utils/mixins/alert_mixin';
import {
  validate_non_empty_string,
  validate_non_sub_zero_number
} from '@/utils/validations/validate_inputs';
import axios from 'axios';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import $ from 'jquery';
import NavigationBackButton from "@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue";

export default {
  name: 'DocumentsManagment',
  mixins: [alert_mixin],
  components: { GlobalTable,NavigationBackButton },
  data: () => ({
    headers: get_headers(),
    token: get_token(),
    project_id: get_project_id(),
    roles: [],
    entity_types : [],
    selected_entity_types: [],
    selected_roles: [],
    selected_workflow: null,
    templates: [],
    workflow_name: '',
    workflow_description: '',
    signing_workflows: [],
    selected_signing_workflow: null,
    view_workflow: {
      name: "",
      description: "",
      roles: []
    },
    selected_template_id: null,
    workflow_assignments: [],
    update_workflow_name: '',
    update_workflow_description: '',
  }),

  mounted() {
    this.get_user_roles();
    this.get_entity_types();
    this.get_uploaded_templates();
    this.view_signing_workflow();
    this.get_workflow_assignments();
  },

  methods: {
    initialize_data_table() {
      this.$nextTick(() => {
        $('#assign_template_table').DataTable({
          responsive: true,
          emptyTable: "No data available in table",
          language: {
            info: "",
            lengthMenu: "_MENU_&nbsp;&nbsp;Entries per page"
          }
        });
      });
    },

    get_user_roles() {
      axios.get(ROLES_URL, {
        headers: this.headers,
      })
      .then(response => {
        this.roles = response.data.data.map(role => ({
          id: role.id,
          role: role.role === "Entity" ? "Founder" : role.role,
        }));
      })
      .catch(error => {
        this.show_error('Error fetching roles: ' + error.message);
      });
    },

    async get_entity_types() {
      this.entity_types = [];

      const project_id = parseInt(this.project_id, 10);

      if (!validate_non_sub_zero_number(project_id)) {
        this.show_error('Project Id must not be null');
        return;
      }

      const params = { project_id: project_id };

      axios.get(VIEW_ENTITY_TYPE_URL, {
        headers: this.headers,
        params: params
      })
      .then(response => {
        const response_data = response.data;
        if (response_data.status === 'success') {
          this.entity_types = response_data.data;
        } else {
          this.show_error('Error retrieving entity types');
        }
      })
      .catch(error => {
        if (error.response && error.response.data) {
          this.show_error('Error retrieving entity types: ' + error.response.data.message);
        } else {
          this.show_error('Unknown error retrieving entity types');
        }
      });
    },

    async get_uploaded_templates() {
      const params = { project_id: this.project_id };

      try {
        const response = await axios.get(LIST_TEMPLATE_VIEW_URL, {
          headers: this.headers,
          params: params,
        });
        const response_data = response.data;
        this.templates = response_data.data.map((template) => ({
          id: template.id,
          name: template.name,
        }));
        this.initialize_data_table();
      } catch (error) {
        this.show_error(`Error fetching templates: ${error.response?.data?.message || error.message}`);
      }
    },

    async create_signing_workflow() {
      if (!validate_non_empty_string(this.workflow_name)) {
        this.show_error('Workflow name must not be empty');
        return;
      }

      if (!validate_non_empty_string(this.workflow_description)) {
        this.show_error('Workflow description must not be empty');
        return;
      }

      if (this.selected_entity_types.length === 0) {
        this.show_error('Please select at least one role.');
        return;
      }

      const payload = {
        name: this.workflow_name,
        description: this.workflow_description,
        steps: this.selected_entity_types.map((type, index) => ({
          entity_type_id: type.id,
          order: index + 1,
        })),
      };

      try {
        const response = await axios.post(CREATE_WORKFLOW, payload, {
          headers: this.headers,
          params: {
            project_id: this.project_id
          }
        });

        if (response.data.status === 'success') {
          this.show_success(response.data.message || 'Workflow created successfully.');
          this.workflow_name = '';
          this.workflow_description = '';
          this.selected_roles = [];
          window.location.reload();
          this.close_modal('create_signing_workflow');
        } else if (response.data.errors) {
          const errorMessages = Object.values(response.data.errors)
            .flat()
            .join('\n');
          this.show_error(`Validation errors:\n${errorMessages}`);
        } else {
          this.show_error(response.data.message || 'Error during workflow creation');
        }
      } catch (error) {
        if (error.response) {
          if (error.response.status === 400) {
            if (error.response.data.errors) {
              const errorMessages = Object.values(error.response.data.errors)
                .flat()
                .join('\n');
              this.show_error(`Validation errors:\n${errorMessages}`);
            } else {
              this.show_error(error.response.data.message || 'Invalid request data');
            }
          } else if (error.response.status === 500) {
            this.show_error('Server error occurred while creating workflow');
          }
        } else if (error.request) {
          this.show_error('No response received from server');
        } else {
          this.show_error(`Error setting up request: ${error.message}`);
        }
      }
    },

    async view_signing_workflow() {
      const params = { project_id: this.project_id };

      try {
        const response = await axios.post(LIST_WORFLOWS, {}, {
          headers: this.headers,
          params: params,
        });
        const response_data = response.data;
        this.signing_workflows = response_data.workflows.map((workflow) => ({
          id: workflow.id,
          name: workflow.name,
          description: workflow.description || '',
        }));
      } catch (error) {
        const error_message = error.response?.data?.message || error.response?.data?.detail || error.message;
        this.show_error(`Error fetching workflows: ${error_message}`);
      }
    },

    async get_workflow(workflow_id) {
      this.selected_signing_workflow = workflow_id;

      try {
        const response = await axios.post(GET_WORKFLOW, {
          workflow_id: this.selected_signing_workflow
        }, {
          headers: this.headers
        });

        const workflow_steps = response.data.workflow || response.data.data;
        if (!workflow_steps) {
          this.show_error('No workflow information found.');
          return;
        }

        this.view_workflow = {
          id: workflow_steps.id,
          name: workflow_steps.name,
          description: workflow_steps.description,
          entity_types: workflow_steps.steps || [],
        };
      } catch (error) {
        this.show_error(
          `Error fetching workflow: ${error.response?.data?.message || error.message}`
        );
      }
    },

    async get_workflow_assignments() {
      const params = { project_id: this.project_id };

      try {
        const response = await axios.post(
          LIST_WORKFLOW_ASSIGNMENTS, {},
          {
            headers: this.headers,
            params: params
          });

        const response_data = response.data;
        if (response_data && Array.isArray(response_data.assignments)) {
          this.workflow_assignments = response_data.assignments.map((assignment) => ({
            id: assignment.id,
            workflow: assignment.workflow_id,
            template: assignment.template_id,
          }));
        } else {
          this.show_error("Received an unexpected response structure from the server.");
          this.workflow_assignments = [];
        }
      } catch (error) {
        this.show_error(`Error fetching workflow assignments: ${error.response?.data?.message || error.message}`);
      }
    },

    is_workflow_assigned(template_id) {
      return this.workflow_assignments.some(
        assignment =>
          assignment.template === template_id &&
          assignment.workflow === this.selected_signing_workflow
      );
    },

    async toggle_workflow_assignment(template_id) {
      const is_currently_assigned = this.is_workflow_assigned(template_id);
      if (is_currently_assigned) {
        await this.unassign_workflow_from_template(template_id);
      } else {
        await this.assign_workflow_to_template(template_id);
      }
    },

    async assign_workflow_to_template(template_id) {
      const workflow_id = this.selected_signing_workflow;

      try {
        const response = await axios.post(
          ASSIGN_WORKFLOW_TO_TEMPLATE,
          { workflow_id, template_id },
          { headers: this.headers }
        );

        if (response.data.status === 'success') {
          this.show_success('Workflow successfully assigned to template!');
          await this.get_workflow_assignments();
        } else {
          this.show_error(response.data.message || 'Error assigning workflow.');
        }
      } catch (error) {
        this.show_error(`Error assigning workflow: ${error.response?.data?.message || error.message}`);
      }
    },

    async unassign_workflow_from_template(template_id) {
      const workflow_id = this.selected_signing_workflow;

      try {
        const response = await axios.post(
          UNASSIGN_WORKFLOW_FROM_TEMPLATE,
          { workflow_id, template_id },
          { headers: this.headers }
        );

        if (response.data.status === 'success' || response.data.message === 'success') {
          this.show_success('Workflow successfully unassigned from template!');
          await this.get_workflow_assignments();
        } else {
          this.show_error(response.data.message || 'Error unassigning workflow.');
        }
      } catch (error) {
        this.show_error(`Error unassigning workflow: ${error.response?.data?.message || error.message}`);
      }
    },

    get_selected_workflow_id(row) {
      this.selected_signing_workflow = row.id;
    },

    prepare_create_workflow() {
      this.workflow_name = '';
      this.workflow_description = '';
      this.selected_entity_types = [];
    },

    async prepare_update_workflow(row) {
      await this.get_workflow(row.id);
      this.update_workflow_name = this.view_workflow.name;
      this.update_workflow_description = this.view_workflow.description;
      this.selected_entity_types = this.view_workflow.entity_types.map(step => {
        return this.entity_types.find(type => type.id === step.entity_type_id);
      }).filter(Boolean);
    },

    async update_signing_workflow() {
      if (!validate_non_empty_string(this.update_workflow_name)) {
        this.show_error('Workflow name must not be empty');
        return;
      }

      if (!validate_non_empty_string(this.update_workflow_description)) {
        this.show_error('Workflow description must not be empty');
        return;
      }

      if (this.selected_entity_types.length === 0) {
        this.show_error('Please select at least one entity type.');
        return;
      }

      const payload = {
        workflow_id: this.view_workflow.id,
        name: this.update_workflow_name,
        description: this.update_workflow_description,
        steps: this.selected_entity_types.map((type, index) => ({
          entity_type_id: type.id,
          order: index + 1,
        })),
      };

      try {
        const response = await axios.post(UPDATE_WORKFLOW_URL, payload, {
          headers: this.headers
        });

        if (response.data.status === 'success') {
          this.show_success('Workflow updated successfully.');
          this.close_modal('update_signing_workflow');
          window.location.reload();
        } else {
          this.show_error(response.data.message || 'Failed to update workflow');
        }
      } catch (error) {
        this.show_error(
          `Error updating workflow: ${error.response?.data?.message || error.message}`
        );
      }
    },
  }
}